import { GET_CLIENT, GET_CLIENT_ROLES,CREATE_CLIENT_ROLE,DEL_CLIENT_ROLE,ADD_SITE, UPDATE_SITE, DEL_SITE, GET_DEPARTMENT, ADD_DEPARTMENT, UPDATE_DEPARTMENT, DEL_DEPARTMENT } from "@/api/role_management";
import querystring from "query-string";

const state = {
    client: [],
    client_roles: [],
    clientRoles: [],
    list_site: [],
    list_department: [],
};

const mutations = {
    SET_CLIENT: (state, payload) => {
        state.client = payload;
    },
    ADD_CLIENT_ROLE(state, role) {
        state.clientRoles.push(role);
    },
    SET_CLIENT_ROLES: (state, payload) => {
        state.client_roles = payload;
    },
    REMOVE_CLIENT_ROLE(state, roleName) {
        state.clientRoles = state.clientRoles.filter(role => role.name !== roleName);
    },
    SET_LIST_SITE: (state, payload) => {
        state.list_site = payload;
        console.log("payload : ", payload)
    },
    SET_LIST_DEPARTMENT: (state, payload) => {
        state.list_department = payload;
    },
};

const actions = {
    getClient: async ({ commit }, params) => {
        params = querystring.stringify(params);
        const resp = await GET_CLIENT(params);
        const data = resp.data.result.data.rows;

        commit("SET_CLIENT", data);
    },
    getClientRoles: async ({ commit }, clientId) => {
        const resp = await GET_CLIENT_ROLES(clientId);
        const data = resp.data;
        commit("SET_CLIENT_ROLES", data);
    },
    createClientRole: async ({ commit }, { clientId, roleData }) => {
        try {
            const resp = await CREATE_CLIENT_ROLE(clientId, roleData);
            const data = resp.data;
            commit("ADD_CLIENT_ROLE", data);
        } catch (error) {
            console.error("Error creating client role:", error);
        }
    },
    deleteClientRole: async ({ commit }, { clientId, roleName }) => {
        try {
            await DEL_CLIENT_ROLE(clientId, roleName);
            commit("REMOVE_CLIENT_ROLE", roleName);
        } catch (error) {
            console.error("Error deleting client role:", error);
        }
    },

    // getListSite: async ({ commit }, params) => {
    //     params = querystring.stringify(params);
    //     const resp = await GET_SITE(params);
    //     const data = resp.data.result;

    //     commit("SET_LIST_SITE", data);
    // },

    createSite: async ({ }, args) => {
        return await ADD_SITE(args);
    },
    updateSite: async ({ }, args) => {
        return await UPDATE_SITE(args);
    },
    delSite: async ({ }, id) => {
        return await DEL_SITE(id);
    },
    getListDepartment: async ({ commit }, params) => {
        params = querystring.stringify(params);
        const resp = await GET_DEPARTMENT(params);

        const data = resp.data.result;
        commit("SET_LIST_DEPARTMENT", data);
    },

    createDepartment: async ({ }, args) => {
        return await ADD_DEPARTMENT(args);
    },
    updateDepartment: async ({ }, args) => {
        return await UPDATE_DEPARTMENT(args);
    },
    delDepartment: async ({ }, id) => {
        return await DEL_DEPARTMENT(id);
    },

};

const getters = {
    client: (state) => state.client,
    client_roles: (state) => state.client_roles,
    listSite: (state) => state.list_site,
    listDepartment: (state) => state.list_department,
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
